import { supabase } from '@/lib/supabase';

/** Платная подписка действует сейчас (пробный период не считается). */
export function isPaidNow(profile: any): boolean {
  if (!profile) return false;
  const exp = profile.subscription_expires_at ? new Date(profile.subscription_expires_at) : null;
  return profile.subscription_status === 'active' && (!exp || exp > new Date());
}

export type PromoOffer = { available: boolean; until: Date | null };

/**
 * Срок цены первого месяца 990 ₽ (миграция 068). Срок ставит сервер один раз:
 * конец пробного периода + 48 часов. В приложении — без таймеров обратного
 * отсчёта (решение Славы 30.10.2026): только словами и датой.
 * Ошибка или старая база без функции → null: экран ведёт себя как раньше.
 */
export async function fetchPromoOffer(): Promise<PromoOffer | null> {
  try {
    const { data, error } = await supabase.rpc('get_promo_offer');
    if (error || !data || data.error) return null;
    return { available: !!data.available, until: data.until ? new Date(data.until) : null };
  } catch {
    return null;
  }
}

const MONTHS = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
/** «до 2 ноября, 21:00» */
export function untilLabel(d: Date): string {
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `до ${d.getDate()} ${MONTHS[d.getMonth()]}, ${hh}:${mm}`;
}
